
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import ISolvability from "@/types/solvability.interface";
import IComptage from "@/types/comptage.interface";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";

@Component({
  components: {TooltipDialog}
})
export default class SolvabilityFilterComptage extends Vue {

  @Prop() readonly product: IComptage;
  @Prop() readonly loadingFilter: boolean;
  currentScore: ISolvability;

    @Watch('product.filters.score', {deep: true})
    refresh() {
        this.currentScore = this.product.filters.score;
        this.$forceUpdate();
    }

  created() {
    this.currentScore = this.product.filters.score;
  }

  emitValue(key: string, value: boolean) {
    this.$emit('set-score', key, value);
  }

}
